// extracted by mini-css-extract-plugin
export var boxItems = "_83-1";
export var button = "_83-5";
export var filterGroupBox = "_83-0";
export var icon = "_83-2";
export var iconSecondary = "_83-4";
export var iconWrapper = "_83-3";